import React, { useEffect, useRef } from 'react'

import styled from 'styled-components'
import { useHistory, useParams } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'

import RequestorDetails from './components/RequestorDetails'
import JobDetails from './components/JobDetails'
import PaymentAndBenefits from './components/PaymentAndBenefits'
import Qualifications from './components/Qualifications'
import Others from './components/Others'

import CircularMultiStepForm from '../../components/CircularMultiStepForm'

import AuthLayouts from '../../layouts/AuthLayouts'

import apiClient from '../../helpers/apiClient'

const VacancyRequestForm = () => {
  const { token } = useParams()

  const formRef = useRef(null)

  const history = useHistory()

  const steps = [
    {
      value: 1,
      text: 'Requestor Details',
      active: true,
      disabled: false,
      form: <RequestorDetails ref={formRef} />,
    },
    {
      value: 2,
      text: 'Job Details',
      active: false,
      disabled: true,
      form: <JobDetails ref={formRef} />,
    },
    {
      value: 3,
      text: 'Payment and Benefits',
      active: false,
      disabled: true,
      form: <PaymentAndBenefits ref={formRef} />,
    },
    {
      value: 4,
      text: 'Qualifications',
      active: false,
      disabled: true,
      form: <Qualifications ref={formRef} />,
    },
    {
      value: 5,
      text: 'Others',
      active: false,
      disabled: true,
      form: <Others ref={formRef} />,
    },
  ]

  useEffect(() => {
    apiClient
      .get(`/validate-token?token=${token}`)
      .then((res) =>
        localStorage.setItem('vacancyRequestToken', res.data.result)
      )
      .catch(() => history.push('/vacancy-request/failed'))
  }, [])

  return (
    <AuthLayouts width="750px">
      <StyledVacancyRequestForm>
        <Toaster position="top-right" reverseOrder={false} />
        <CircularMultiStepForm
          steps={steps}
          multiStepFormName="vacancyRequest"
          formRef={formRef}
        />
      </StyledVacancyRequestForm>
    </AuthLayouts>
  )
}

export const StyledVacancyRequestForm = styled.section`
  width: 100%;
  display: flex;
  align-items: flex-start;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`

export default VacancyRequestForm
